import { Suboperation } from './../../_models/suboperation';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Nip } from 'src/app/_models/nip';
import { MessService } from 'src/app/_services/mess-service.service';
import { NipService } from 'src/app/_services/nip.service';
import { OperationsService } from 'src/app/_services/operations.service';

@Component({
  selector: 'app-nip-worker-edit',
  templateUrl: './nip-worker-edit.component.html',
})
export class NipWorkerEditComponent implements OnInit, OnDestroy {
  loading = true;
  started = false;
  stopped = false;
  notSaved = false;
  pauseStart = false;
  pauseStop = false;
  pausedTime = 0;
  totalTime: string;

  subOperationSelected = false;
  selectedOperation: any;
  idOfSelectedSuboperation: number;
  subOpFromAvailableProdOp: any;
  arrOfSuboperation = [];

  saveNipForm: FormGroup;
  startNipForm: FormGroup;
  stopNipForm: FormGroup;
  delayReasonsForm: FormGroup;

  timeStart: Date;
  timeStop: Date;

  nipForUpdate: Nip = new Nip();

  editNipActive = false;
  nipOnStartForm: any;

  activeNip: any;

  displayModal: boolean = false;

  delayReasons = [
    { name: 'Pauza/Ručak', code: 'lunch_break' },
    { name: 'Pomoć - Prijem robe', code: 'help_reciving_package' },
    { name: 'Pomoć - Utovar robe', code: 'help_delivery_package' },
    { name: 'Kvar - Mašina (Alat)', code: 'failure' },
    { name: 'Nedostatak - Materijal', code: 'no_material' },
    { name: 'Nedostatak - TD', code: 'no_td' },
    { name: 'Ostalo', code: 'other' },
  ];

  delayTime = new Date('January 31 2000 0:0');
  chosenOperation: number;

  scrapReasons = [
    { name: 'Ljudski faktor', code: 'human_factor' },
    { name: 'Nejasna TD', code: 'no_defined_td' },
    { name: 'Kvalitet materijala', code: 'material_quality' },
    { name: 'Ispravnost mašine', code: 'machine_failure' },
    { name: 'Ostalo', code: 'other' },
  ];

  subscriptions: Subscription[] = [];

  allOperations = [];
  allSubOperations = [];

  constructor(
    private fb: FormBuilder,
    private nipService: NipService,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute,
    private operationsService: OperationsService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.editNipActive = false;
    // * Create form for SAVE
    this.saveNipForm = this.fb.group({
      product_operation_rel_id: [{ value: '' }, Validators.required],
      documentation_correct: [],
      produced_amount: ['', Validators.required],
      scrap_reasons: [[]],
      // delay_reasons: [[]],
      // delay_duration: [''],
      scrap_amount: [''],
      comment: [''],
      operation_id: ['', Validators.required],
      suboperation_id: [''],
    });

    // * Get all operations
    this.subscriptions.push(
      this.operationsService.getAllNoPagination().subscribe((res) => {
        this.allOperations = res;
      })
    );

    // * Delay reasons form for start/stop pause
    this.delayReasonsForm = this.fb.group({
      delay_reasons: [[]],
    });

    // * Create form for START
    this.startNipForm = this.fb.group({
      product_operation_rel_id: [''],
      suboperation_id: [''],
    });

    // * Create form for STOP
    this.stopNipForm = this.fb.group({
      product_operation_rel_id: [''],
      product_suboperation_rel_id: [''],
    });

    this.updateNipData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  getOneNip(id: number) {
    this.subscriptions.push(
      this.nipService.getNipById(id).subscribe({
        next: (nip: any) => {
          this.setUpdateNipData(nip);
        },
        error: (error) => {},
      })
    );
  }

  setUpdateNipData(nip: any) {
    // nip = {
    //   ...nip,
    //   allSubOperations: nip.available_prod_ops[0],
    // };
    this.activeNip = nip;

    if (
      this.activeNip?.active_time_tracker !== null &&
      this.activeNip?.active_time_tracker?.active_break_tracker !== null
    ) {
      // this.pauseStart = true;
    }

    if (!nip) {
      this.router.navigate(['./../'], { relativeTo: this.route });
      return;
    } else {
      this.nipForUpdate = nip;

      if (nip.active_time_tracker) {
        this.timeStart = new Date(nip.active_time_tracker.start);
        this.started = true;
        this.chosenOperation = nip.active_time_tracker.product_operation_rel_id;

        this.totalTime = nip.active_time_tracker.total_time;

        this.saveNipForm.patchValue({
          product_operation_rel_id:
            nip.active_time_tracker.product_operation_rel_id,
        });

        this.stopNipForm.patchValue({
          product_operation_rel_id:
            nip.active_time_tracker.product_operation_rel_id,
        });

        // * Remove validation for operation_id if active_time_tracker is active and has value
        this.saveNipForm.get('operation_id').clearValidators();
      }
      if (nip.active_time_tracker && nip.active_time_tracker.end) {
        this.timeStop = new Date(nip.active_time_tracker.end);
        this.notSaved = true;
      }

      this.startNipForm.patchValue({
        product_operation_rel_id: nip.current_product_operation_rel_id,
      });

      if (this.nipForUpdate.available_prod_ops[0]) {
        this.choseOperationForWork(this.nipForUpdate.available_prod_ops[0].id);
      }

      if (this.nipForUpdate.active_time_tracker) {
        this.choseOperationForWork(
          this.nipForUpdate.active_time_tracker.product_operation_rel_id
        );
      }

      if (this.nipForUpdate.enable_add_operations) {
        this.startNipForm.addControl('operation_id', this.fb.control(''));
        this.startNipForm.removeControl('product_operation_rel_id');
      }

      this.selectedOperation = nip?.available_prod_ops[0]?.id;

      const { product_operation_rel_id } = this.saveNipForm.value;
      const { planned_units, produced_totals } = nip;
      const produced_total = produced_totals[product_operation_rel_id];
      const total_produced = planned_units - produced_total;

      this.selectedOperation = this.nipForUpdate?.current_op?.id;
      this.subOpFromAvailableProdOp =
        this.nipForUpdate.available_prod_ops[0]?.suboperations;

      // if (total_produced > 0) {
      //   this.saveNipForm
      //     .get('produced_amount')
      //     .setValidators([Validators.max(planned_units - produced_total)]);
      // }
      if (nip?.active_time_tracker.start) {
        this.started = true;
      }

      if (nip.active_time_tracker.end) {
        this.stopped = true;
      }

      if (
        nip?.active_time_tracker?.active_break_tracker?.start &&
        !nip.active_time_tracker?.active_break_tracker?.end
      ) {
        this.pauseStart = true;
      }
    }
  }

  updateNipData() {
    // * Get data for update
    this.subscriptions.push(
      this.nipService.updateNipData.subscribe((nip: Nip) => {
        this.arrOfSuboperation = nip.available_prod_ops[0]?.suboperations;
        this.setUpdateNipData(nip);
      })
    );
  }

  // * SAVE NIP === //
  onSaveNip() {
    const saveNip = this.saveNipForm.getRawValue();
    let isFormValid = false;

    saveNip.product_operation_rel_id = this.chosenOperation;

    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    saveNip.product_suboperation_rel_id = subOperationValue;

    if (saveNip.scrap_amount && saveNip.scrap_reasons.length !== 0) {
      isFormValid = true;
    }
    if (saveNip.scrap_amount && saveNip.scrap_reasons.length === 0) {
      isFormValid = false;
    }
    if (isFormValid) {
      this.subscriptions.push(
        this.nipService.saveNip(this.nipForUpdate.id, saveNip).subscribe(
          (success) => {
            this.messService.add({
              severity: 'success',
              title: 'Merenje vremena',
              detail: 'Uspešno ste sačuvali unos.',
            });
            this.router.navigate(['./../'], { relativeTo: this.route });
          },
          (error) => {
            const errorObj = error.error.errors;
            const form = this.saveNipForm;
            const messService = this.messService;
            Object.keys(errorObj).forEach(function (key) {
              const formControl = form.get(key);
              if (formControl) {
                // If error exist set red border to field
                formControl.setErrors({});
              }
              // Push toast error for every field
              messService.addError({
                severity: 'error',
                title: 'Greška',
                detail: errorObj[key],
                sticky: true,
              });
            });
          }
        )
      );
    } else {
      this.messService.addError({
        severity: 'error',
        title: 'Greška',
        detail: 'Morate uneti razlog škarta',
        sticky: true,
      });
    }

    // if (this.nipForUpdate.enable_add_operations === false) {
    //   saveNip.product_operation_rel_id = saveNip.product_operation_rel_id;

    //   // this.arrOfSuboperation.forEach((operation) => {
    //   //   if (
    //   //     this.activeNip.active_time_tracker.product_suboperation_rel_id ===
    //   //     operation.suboperation_id
    //   //   ) {
    //   //     saveNip.product_suboperation_rel_id = operation.id;
    //   //   }
    //   // });
    // }
    // if (this.nipForUpdate.enable_add_operations) {
    //   const subOperationValue =
    //     this.activeNip.active_time_tracker.product_suboperation_rel_id;
    //   saveNip.product_suboperation_rel_id = subOperationValue;
    // }
  }

  // * START === //
  onStart() {
    const nipStart = this.startNipForm.getRawValue();
    const subOperationValue = this.saveNipForm.getRawValue();
    nipStart.suboperation_id = subOperationValue.suboperation_id;
    this.nipOnStartForm = nipStart;

    if (!this.nipForUpdate.enable_add_operations) {
      delete Object.assign(nipStart, {
        product_suboperation_rel_id: nipStart.suboperation_id,
      })['suboperation_id'];
    }

    // IF WORKER CANT SELECT OPERATIONS
    if (this.nipForUpdate.enable_add_operations === false) {
      this.arrOfSuboperation.forEach((operation) => {
        if (
          nipStart.product_suboperation_rel_id === operation.suboperation_id
        ) {
          nipStart.product_suboperation_rel_id = operation.id;
        }
      });
    }
    this.subscriptions.push(
      this.nipService.startNip(this.nipForUpdate.id, nipStart).subscribe(
        (success: any) => {
          if (success.status === 200) {
            this.started = true;

            this.timeStart = new Date();

            this.getOneNip(this.nipForUpdate.id);
          }

          if (this.nipForUpdate.enable_add_operations) {
            this.choseOperationForWork(
              success.body[0].product_operation_rel_id
            );
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste pokrenuli merenje vremena.',
          });

          this.editNipActive = true;
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.startNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * STOP === //
  onStop() {
    // this.saveNipForm.patchValue({
    //   time_stop: new Date(),
    //   time: this.getTimeDiff(this.getControls.time_start.value, new Date()),
    // });

    const nipStop = this.stopNipForm.getRawValue();
    this.idOfSelectedSuboperation =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    nipStop.product_suboperation_rel_id = subOperationValue;

    this.subscriptions.push(
      this.nipService.stopNip(this.nipForUpdate.id, nipStop).subscribe(
        (success: any) => {
          if (success.total_time) {
            this.started = false;
            this.stopped = true;
            this.timeStop = new Date();
            this.totalTime = success.total_time;
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste zaustavili merenje vremena.',
          });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  onCancel() {
    const nipCancel = this.stopNipForm.getRawValue();

    this.subscriptions.push(
      this.nipService.cancelNip(this.nipForUpdate.id, nipCancel).subscribe(
        (success: any) => {
          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste otkazali merenje vremena.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * PAUSE START === //
  onStartPause() {
    this.displayModal = true;

    // const nipStartPause = this.stopNipForm.getRawValue();
    // const subOperationValue =
    //   this.activeNip.active_time_tracker.product_suboperation_rel_id;
    // nipStartPause.product_suboperation_rel_id = subOperationValue;

    // this.subscriptions.push(
    //   this.nipService.startPause(this.nipForUpdate.id, nipStartPause).subscribe(
    //     (success: any) => {
    //       if (success.total_time) {
    //         this.started = false;
    //         this.stopped = true;
    //         this.timeStop = new Date();
    //         this.totalTime = success.total_time;
    //       }

    //       this.messService.add({
    //         severity: 'success',
    //         title: 'Merenje vremena',
    //         detail: 'Uspešno ste zaustavili merenje vremena.',
    //       });
    //     },
    //     (error) => {
    //       const errorObj = error.error.errors;
    //       const form = this.stopNipForm;
    //       const messService = this.messService;
    //       Object.keys(errorObj).forEach(function (key) {
    //         const formControl = form.get(key);
    //         if (formControl) {
    //           // If error exist set red border to field
    //           formControl.setErrors({});
    //         }
    //         // Push toast error for every field
    //         messService.addError({
    //           severity: 'error',
    //           title: 'Greška',
    //           detail: errorObj[key],
    //           sticky: true,
    //         });
    //       });
    //     }
    //   )
    // );
  }

  onStopPause() {
    this.pauseStart = false;
    this.pauseStop = true;

    const nipStartPause = this.stopNipForm.getRawValue();
    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    nipStartPause.product_suboperation_rel_id = subOperationValue;

    this.subscriptions.push(
      this.nipService.stopPause(this.nipForUpdate.id, nipStartPause).subscribe(
        (success: any) => {
          if (success.total_time) {
            this.started = false;
            this.stopped = true;
            this.timeStop = new Date();
            this.totalTime = success.total_time;
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste zaustavili merenje vremena.',
          });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  onSavePause() {
    const nipStopPause = this.stopNipForm.getRawValue();
    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    nipStopPause.product_suboperation_rel_id = subOperationValue;

    let finalNip = {
      ...nipStopPause,
      ...this.delayReasonsForm.getRawValue(),
    };
    this.pauseStart = true;

    this.subscriptions.push(
      this.nipService.startPause(this.nipForUpdate.id, finalNip).subscribe(
        (success: any) => {
          if (success.total_time) {
            this.started = false;
            this.stopped = true;
            this.timeStop = new Date();
            this.totalTime = success.total_time;
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste započeli merenje vremena.',
          });

          this.displayModal = false;
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * Helpers === //

  choseOperationForWork(event) {
    this.chosenOperation = event;

    this.startNipForm.patchValue({
      product_operation_rel_id: event,
    });

    this.stopNipForm.patchValue({
      product_operation_rel_id: event,
    });

    this.allSubOperations =
      this.nipForUpdate.available_prod_ops[0]?.suboperations;
  }

  choseFromAllOperations(event) {
    this.allOperations.forEach((operation) => {
      if (operation.id === event) {
        this.allSubOperations = operation.suboperations;
      }
    });

    this.chosenOperation = event;
    this.startNipForm.patchValue({
      operation_id: event,
    });
  }

  addReasonToForm(event, field) {
    this.delayReasonsForm.patchValue({
      [field]: event.value,
    });
  }

  onChoseDelayTime(event: Date) {
    let hours =
      event.getHours().toString.length < 2
        ? '0' + event.getHours()
        : event.getHours();
    let minutes =
      event.getMinutes().toString.length < 2
        ? '0' + event.getMinutes()
        : event.getMinutes();
    let seconds =
      event.getSeconds().toString.length < 2
        ? '0' + event.getSeconds()
        : event.getSeconds();
  }

  get getControls() {
    return (<FormGroup>this.saveNipForm).controls;
  }

  getTimeDiff(startDate, endDate) {
    let distance = Math.abs(startDate - endDate);
    const hours = Math.floor(distance / 3600000);
    distance -= hours * 3600000;
    const minutes = Math.floor(distance / 60000);
    distance -= minutes * 60000;
    const seconds = Math.floor(distance / 1000);

    return `${hours}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
  }

  suboperationSelected() {
    this.subOperationSelected = true;

    // // this.saveNipForm.controls.operation_id.invalid =false
    // this.saveNipForm.controls['operation_id'].clearValidators()
  }
}
